import { render, staticRenderFns } from "./SignUpHero.vue?vue&type=template&id=b94aa9de&scoped=true"
import script from "./SignUpHero.vue?vue&type=script&lang=js"
export * from "./SignUpHero.vue?vue&type=script&lang=js"
import style0 from "./SignUpHero.vue?vue&type=style&index=0&id=b94aa9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94aa9de",
  null
  
)

export default component.exports